import useEnvPermission from '@elementary/common-ui/hooks/useEnvPermission';
import { AccountEnvironment } from '@elementary/common-ui/types';
import dayjs from 'dayjs';

const useIsSyncEnabled = (envData: AccountEnvironment): boolean => {
  const hasPermission = useEnvPermission();
  const lastSyncTime = envData?.lastSyncedAt;
  const currentTime = dayjs();
  const tenMinutesAgo = dayjs().subtract(10, 'minute');
  if (envData.lastSyncStatus === 'running' || !hasPermission('TRIGGER_SYNC')) {
    return false;
  }
  if (lastSyncTime) {
    const lastSyncedAt = dayjs(lastSyncTime);
    if (
      lastSyncedAt.isAfter(tenMinutesAgo) &&
      lastSyncedAt.isBefore(currentTime)
    ) {
      return false;
    }
    return true;
  }
  return true;
};

export default useIsSyncEnabled;
